import script from "./ElderlySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ElderlySelect.vue?vue&type=script&setup=true&lang=js"

import "./ElderlySelect.vue?vue&type=style&index=0&id=7975cbc8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7975cbc8"]])

export default __exports__